import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list-view-active",
  "use": "list-view-active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"list-view-active\">\n  <path fill=\"#677078\" d=\"M18,5.01 L0,5 L0,7 L18,7 L18,5.01 Z M0,10 L12,10 L12,12 L0,12 L0,10 Z M18,0 L0,0 L0,2.01 L18,2 L18,0 Z\" transform=\"translate(3 6)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol